<template>
  <div class="notice-wrap">
    <img class="notice-image" :src="url" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: `https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/image/pc_limit.jpg?_t=${Date.now()}`
    }
  }
}
</script>

<style scoped>
.notice-wrap {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notice-image {
  max-width: 1100px;
}
</style>